import {
  CAFETERIA_SECTIONS_REQUEST,
  CAFETERIA_SECTIONS_SUCCESS,
  CAFETERIA_SECTIONS_FAILURE,
} from '../../actions/cafeteria/sections';


const defaultSections = {
  menu: true,
  settings: true,
  purchases: true,
  orders: true,
  schedule: true,
  finances: true,
  subsidies: true,
};

const defaultState = {
  loading: false,
  free: defaultSections,
  result: null,
};

const sections = (state = defaultState, action) => {
  switch (action.type) {
    case CAFETERIA_SECTIONS_REQUEST: {
      return { ...state, loading: true };
    }
    case CAFETERIA_SECTIONS_SUCCESS: {
      return { ...state, ...action.payload, loading: false };
    }
    case CAFETERIA_SECTIONS_FAILURE: {
      return { ...state, loading: false };
    }

    default:
  }
  return state;
};

export default sections;
